
export const LCA_CATEGORIES = [
  { key: "structure", label: "Structure" },
  { key: "envelope", label: "Envelope" },
  { key: "design", label: "Design" },
  { key: "mechanical", label: "Mechanical equipment" },
  { key: "energy", label: "Energy - B6" }
];

export const INPUT_UNITS = [
  { key: "kg", label: "kg" },
  { key: "t", label: "t" },
  { key: "m3", label: "m³" },
  { key: "m2", label: "m²" },
  { key: "pcs", label: "pcs" }
];

export const DECLARED_UNITS = ["kg", "m3", "m2", "pcs"];

export const LCA_STAGES = [
  { key: "A1A3", label: "A1 to A3" },
  { key: "A4", label: "A4" },
  { key: "A5", label: "A5" },
  { key: "B4", label: "B4 replacement" },
  { key: "B6", label: "B6 operational energy" },
  { key: "C1C4", label: "C1 to C4" },
  { key: "D", label: "D benefits and loads" }
];

// Transport emission factors (kg CO2e per tonne-km)
// Sources: UK Government GHG Conversion Factors for Company Reporting (freight, 2023/24)
export const TRANSPORT_MODES = [
  { key: "road_articulated", label: "Road - Articulated HGV", factorKgPerTkm: 0.062 },
  { key: "road_rigid", label: "Road - Rigid HGV", factorKgPerTkm: 0.08 },
  { key: "road_van", label: "Road - Van / light truck", factorKgPerTkm: 0.18 },
  { key: "rail", label: "Rail freight", factorKgPerTkm: 0.02 },
  { key: "sea", label: "Sea freight (container)", factorKgPerTkm: 0.009 },
  { key: "air_long", label: "Air freight (long haul)", factorKgPerTkm: 0.6 }
];

// Normalized EPD record the calculator uses
// gwp is kg CO2e per declared unit
export function createNormalizedEpd({
  id,
  name,
  source,
  declaredUnit,
  gwp,
  geography
}) {
  return {
    id: String(id),
    name: name || "Untitled EPD",
    source: source || "unknown",
    declaredUnit: declaredUnit, // "kg" | "m3" | "m2" | "pcs"
    geography: geography || null,
    gwp: {
      A1A3: Number(gwp?.A1A3 ?? 0),
      A4: Number(gwp?.A4 ?? 0),
      A5: Number(gwp?.A5 ?? 0),
      B4: Number(gwp?.B4 ?? 0),
      C1C4: Number(gwp?.C1C4 ?? 0),
      D: Number(gwp?.D ?? 0)
    }
  };
}

export function makeId(prefix = "id") {
  try {
    return `${prefix}_${crypto.randomUUID()}`;
  } catch {
    return `${prefix}_${Math.random().toString(16).slice(2)}_${Date.now()}`;
  }
}

export function clampNumber(value, fallback = 0) {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}
